import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { Alert } from "@mui/material";
import axios from "axios";
import { QrReader } from "react-qr-reader";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function EditList({
  handleClose,
  refreshAssets,
  listName,
  listId,
  listAssets,
}) {
  console.log(listAssets);
  const url = process.env.REACT_APP_URL;
  const [assets, setAssets] = useState(listAssets);
  const [assetId, setAssetId] = useState("");
  const [scanned, setScanned] = useState(false);
  const [scannedAsset, setScannedAsset] = useState(0);
  //Alerts & Loader
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    if (scannedAsset != 0) {
      addAsset(scannedAsset);
    }
  }, [scannedAsset]);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const addAsset = async (assetId) => {
    setAssetId("");
    await axios
      .post(`${url}/assets/fetch-asset`, { assetId: assetId })
      .then(async (res) => {
        let _asset = res.data.asset;
        console.log(_asset);

        if (!_asset.checkedIn || _asset.disabled || _asset.archived) {
          handleAlert(
            "This asset is already checked out, is disabled or is archived",
            "warning"
          );
          return;
        }

        let assetExists = assets.findIndex((a) => {
          return a.assetId == _asset.assetId;
        });

        if (assetExists >= 0) {
          handleAlert("Asset already in list", "warning");
        } else {
          setAssets((prevItems) => [
            {
              assetId: _asset.assetId,
              assetName: _asset.assetName,
              serialNumber: _asset.serialNumber,
            },
            ...prevItems,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  const removeAsset = async (assetId, assetName) => {
    if (assets.length === 1) {
      handleAlert(
        "List must have at least one asset in list",
        "warning",
        false,
        2000
      );
      return;
    }
    let filteredAssets = assets.filter((a, i) => {
      return a.assetId != assetId;
    });
    setAssets(filteredAssets);
    console.log(filteredAssets);

    //CHECK ASSET BACK IN
    let reqBody = {
      assetId: assetId,
      locationId: 4,
      assetName: assetName,
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
    };

    await axios
      .post(`${url}/assets/check-in`, reqBody)
      .then((res) => {
        console.log("Asset checked back in");
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });

    await handleEditList(filteredAssets, false);
  };

  const handleEditList = async (_assets, close = true) => {
    //Remove any list duplicates

    const uniqueArray = _assets.filter(
      (value, index, self) =>
        self.findIndex((item) => item.assetId === value.assetId) === index
    );

    let reqBody = {
      currentUser: localStorage.getItem("userId"),
      currentUsername: localStorage.getItem("username"),
      listId: listId,
      listAssets: uniqueArray,
      listName: listName,
    };
    console.log(reqBody);
    await axios
      .post(`${url}/assets/edit-asset-list`, reqBody)
      .then(async (res) => {
        if (close) {
          handleAlert("List updated", "success", true, 2000);
        } else {
          handleAlert("List updated", "success", false, 1000);
        }

        refreshAssets();
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Something went wrong - Please try again", "error");
      });
  };

  return (
    <Box className="list-modal">
      <section className="list-section">
        <h2>Edit List - {listName}</h2>
        <form>
          {!scanned ? (
            <QrReader
              onResult={(result, error) => {
                if (result?.text) {
                  setScannedAsset(result?.text);
                  setTimeout(() => {
                    setScannedAsset(0);
                  }, 2000);
                }
              }}
              style={{ width: "100%" }}
              className="qr-reader"
              constraints={{
                facingMode: "environment",
              }}
            />
          ) : (
            <Button
              className="scan-btn"
              variant="contained"
              color="info"
              onClick={() => {
                setScanned(false);
              }}
            >
              Scan Another
            </Button>
          )}{" "}
          <section className="manual-asset">
            <input
              placeholder="Enter Asset ID manually if no QR"
              onChange={(e) => setAssetId(e.target.value)}
              type="text"
              value={assetId}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={assetId === ""}
              onClick={() => {
                addAsset(assetId);
              }}
            >
              <AddCircleIcon />
            </Button>
          </section>
        </form>
        <section className="asset-list-container">
          {assets.length > 0 ? (
            <table className="asset-list-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {assets.map((a, i) => {
                  return (
                    <tr key={i}>
                      <td>{a.assetId}</td>
                      <td>{a.assetName}</td>
                      <td>
                        <IconButton
                          disabled={disable}
                          onClick={() => {
                            removeAsset(a.assetId, a.assetName);
                          }}
                        >
                          <DeleteIcon color="error" fontSize="large" />
                        </IconButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : null}
        </section>
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            onClick={() => {
              refreshAssets();
              handleClose(false);
            }}
            variant="contained"
            color="error"
            disabled={disable}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="success"
            disabled={disable}
            onClick={() => handleEditList(assets)}
          >
            Update
          </Button>
        </section>
      </section>
    </Box>
  );
}
